export var defaultStorageConfig = {
    raw: true,
};
